import React from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const SelectBox = ({
  name,
  value,
  onChange,
  onBlur,
  onClick,
  options,
  option_name = "name",
  option_value = "value",
  loading = false,
  className = "",
  disabled = false,
}) => {
  const { t } = useTranslation("common");

  const emptyOption = options?.find(
    (o) => o[option_value] == null || o[option_value] === ""
  );

  return (
    <Form
      as="select"
      className={`form-control ${className}`.trim()}
      name={name}
      disabled={disabled}
      value={value ?? ""}
      onChange={onChange}
      onBlur={onBlur}
      onClick={onClick}
    >
      {!emptyOption && (
        <option value="">{t("components.selectBox.select")}</option>
      )}
      {loading && <option value="">{t("common:loading")}</option>}
      {!loading &&
        options?.map((option, index) => (
          <option key={index} value={option[option_value] ?? ""}>
            {option[option_name]}
          </option>
        ))}
    </Form>
  );
};

export default SelectBox;
